import { useCallback, useState } from 'react';
import { loadFromInstanceStorage, saveToInstanceStorage } from '../../Helpers/instanceStorage';

export type QueueStatusFilter = 'active' | 'closed' | 'all';
const STORAGE_KEY = 'parkingQueue_status';
const VALID: QueueStatusFilter[] = ['active', 'closed', 'all'];

/** The only remembered view preference: the status filter, per user and instance. */
export const useParkingQueueView = (): { statusFilter: QueueStatusFilter; setStatusFilter: (f: QueueStatusFilter) => void } => {
    const [statusFilter, setState] = useState<QueueStatusFilter>(() => {
        const stored = loadFromInstanceStorage<QueueStatusFilter>(STORAGE_KEY, 'active');
        return VALID.includes(stored) ? stored : 'active';
    });
    const setStatusFilter = useCallback((f: QueueStatusFilter) => {
        setState(f);
        saveToInstanceStorage(STORAGE_KEY, f);
    }, []);
    return { statusFilter, setStatusFilter };
};
